
import {throwError as observableThrowError,  Observable } from 'rxjs';

import {refCount, publishReplay, catchError} from 'rxjs/operators';
import { Injectable, EventEmitter, Output, Inject, OnDestroy} from '@angular/core'
// import { Http, Headers, Response} from '@angular/http'
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http'

import { AuthService } from './auth.service'
import {SharedMethodsModule} from '../insa-custom-scripts/sharedMethods';
import { ClientContactModel } from '../insa-models/client-contact.model'
import { ClientContactTypesModel } from '../insa-models/client-contact.model'
import { appStateProvider } from '../insa-providers/AppStateProvider'
import { appConfig } from '../../insaweb.config'
import { LocalizeService } from './localize.service';

@Injectable()
export class ClientContactService implements OnDestroy{

    private language = 'en';
    private hostAddress = appConfig.insaServiceAddress;
    private servicesURL = "/ClientContacts";

    clientContacts: any;
    clientContactTypes: any;
    authServiceSubscription;
    stateSubscription;

    @Output() ClientContactsEvent: EventEmitter<ClientContactModel[]> = new EventEmitter<ClientContactModel[]>(true);
    @Output() ClientContactTypesEvent: EventEmitter<ClientContactTypesModel[]> = new EventEmitter<ClientContactTypesModel[]>(true);

    constructor(private _appStateProvider: appStateProvider, private http: HttpClient, private _authService: AuthService, private _localize: LocalizeService) {
        this.language = this._localize.getLocale().substring(0, 2);
        this.stateSubscription = _appStateProvider.subscribe(eventdata => this.initDataFetching(eventdata));
        this.authServiceSubscription = this._authService.LoggedInStatusChangedEmitter.subscribe((loggedIn) => {
            (loggedIn.value === false) ?  this.clearData() : this.language = this._localize.getLocale().substring(0, 2);
  
        });
    }

    clearData() {
        this.clientContacts = [];
        this.clientContactTypes = [];
    }
    
    initDataFetching(e) {
        this.language = this._localize.getLocale().substring(0, 2);

        if (appConfig.menuShowClientContacts) {
            this.getClientContacts();
            this.getClientContactTypes();
        } 
    }

    getClientContacts() {
        let headers = this._authService.getAuthHeaders('application/json');
        let timeStamp = +new Date();

        let req = this.http.get(this.hostAddress + this.servicesURL + '?partnerIndex=' +  this._appStateProvider.selectedPartner.value + '&tsp=' + timeStamp,
            { headers })
            .pipe(
                publishReplay(),
                refCount(),
                catchError(err => this.handleError(err, "Could not get any contact! Please, check if your contact list is empty.")))
                //.map(res => res.json())

        req.subscribe(data => {
            this.clientContacts = data,
            console.log(data)
            this.ClientContactsEvent.emit(this.clientContacts),
                this._appStateProvider.fetchingClientContacts = false
        });
        return req;
    }

    deleteClientContacts(contactId) {
        let headers = this._authService.getAuthHeaders('application/json');

        return this.http.delete(this.hostAddress + this.servicesURL + '?contactId=' + contactId, {headers })
            .pipe(
                catchError(err => this.handleError(err, "Could not delete contact with id " + contactId)))

    }

    updateClientContacts(clientContact) {
        let headers = this._authService.getAuthHeaders('application/json');
        let body = JSON.stringify(clientContact);

        return this.http.put(this.hostAddress +  this.servicesURL , body, { headers: headers })
            .pipe(
                catchError(err => this.handleError(err, "Error during update contact. Could not be updated.")));
    }

    addClientContacts(clientContact) {
        let headers = this._authService.getAuthHeaders('application/json');
        let body = JSON.stringify(clientContact);
       return this.http.post(this.hostAddress  + this.servicesURL, body, {headers})
            .pipe(catchError(err => this.handleError(err, "Error during adding contact.")))
    }

    getClientContactTypes() {
       let headers = this._authService.getAuthHeaders('application/json');
       let timeStamp = +new Date();

       let req = this.http.get(this.hostAddress + this.servicesURL +'/ClientContactTypes'+ '?tsp=' + timeStamp,
            { headers }).pipe(publishReplay(),refCount(),)
            .pipe(
                catchError(err => this.handleError(err, "Couldn't get any contact type.")))
            //.map(res => res.json())

        req.subscribe(data => {
            this.clientContactTypes = data,
            this.ClientContactTypesEvent.emit(this.clientContactTypes)
        });
        return req;
    }


    private handleError(error: any, message: string) {
        let errMsg = (error.message) ? error.message :
            error.status ? `${error.status} - ${error.statusText}` : 'Server error';
            SharedMethodsModule.addNotification("#notification", message, false);    
        return observableThrowError(errMsg);
    }

    ngOnDestroy() {
        this.stateSubscription.unsubscribe();
        this.authServiceSubscription.unsubscribe();
    }



}


// WEBPACK FOOTER //
// ./app/insa-services/client-contact.service.ts